import { omProjectConstants } from '../constant/omProject.constants';
import { omProject } from '../services/omProject.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getOmProjectList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        omProject.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(omProjectList) { 
        return { type: omProjectConstants.GET_SUCCESS, omProjectList }; 
    }
}

export const addOmProject = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        omProject.add(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                                dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: omProjectConstants.ADD_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: omProjectConstants.ADD_FAILURE, error }; 
    }
}

export const deleteOmProject = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        omProject.delete(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: omProjectConstants.DELETE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: omProjectConstants.DELETE_FAILURE, error }; 
    }
}

export const updateOmProject = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        omProject.update(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APIUpdatedSuccess:
                            dispatch(success('004'));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.APIInvalids:
                            functionCommon.logout();
                            break;
    
                        case _errorCode.DBCanNotConnect:
                            window.location = '/error/404';
                            break;

                        default:
                            dispatch(failure(res['error_code']));
                            break;
                    }
                   
                }
            );
    };

    function success(code) { 
        return { type: omProjectConstants.UPDATE_SUCCESS, code}; 
    }

    function failure(error) {
        return { type: omProjectConstants.UPDATE_FAILURE, error }; 
    }
}